







import Vue from 'vue'
import { mapGetters, mapMutations } from 'vuex'
import { ThisTypedComponentOptionsWithRecordProps } from 'vue/types/options'
import UiButton from '@/components/ui/UiButton.vue'
import { storeModuleName } from '@/views/App/Profile/store'
import { storeModuleName as uiModule } from '@/store/modules/ui'
import { Deal, DealStageEnum, DealStatusEnum } from '@/requests/mainApi'

interface Data {}

interface Methods {
  setStateDutyModalStatus(status: boolean): void
}

interface Computed {
  deal: Deal
}
interface Props {
  isWhite: boolean
  dealStage: DealStageEnum
  isFromProfile: boolean
}

export default Vue.extend({
  name: 'CompleteDealButton',
  components: {
    UiButton
  },
  props: {
    isWhite: {
      type: Boolean,
      default: () => false
    },
    dealStage: {
      type: String,
      required: true
    },
    isFromProfile: {
      type: Boolean,
      default: () => false
    }
  },
  computed: {
    buttonText () {
      if (this.isFromProfile) return this.$t('app.profile.completeDealButtonTextsProfile.' + this.dealStage)
      return this.$t('app.profile.completeDealButtonTexts.' + this.dealStage)
    },
    ...mapGetters(['deal'])
  },
  methods: {
    onClick () {
      switch (this.dealStage) {
        case 'booking':
        case 'type_of_ownership':
        case 'load_owners':
          this.$router.push('/deal/ownership')
          break
        case 'load_pay_data':
        case 'pay_options':
          this.$router.push('/deal/payment')
          break
        case 'agreement':
          this.$router.push('/deal/contract')
          break
        case 'signing_options':
          this.$router.push('/deal/signing')
          break
        case 'pay_state_duty':
          this.setStateDutyModalStatus(true)
          break
      }
    },
    ...mapMutations(uiModule, ['setStateDutyModalStatus'])
  }
} as ThisTypedComponentOptionsWithRecordProps<Vue, Data, Methods, Computed, Props>)
